import { createAction } from '@reduxjs/toolkit';

import { GeometryClassDefinition } from '@/features/custom-shared/types/editor/classes';
import { GeometryClassInstance } from '@/features/custom-shared/types/editor/instances';
import { JSONProjectFile } from '@/features/custom-shared/types/project';

export const createProjectFile = createAction<
  | {
      type: 'definition';
      file: JSONProjectFile<GeometryClassDefinition>;
    }
  | {
      type: 'instance';
      file: JSONProjectFile<GeometryClassInstance>;
    }
>('project/createFile');
export const exitEditor = createAction('editor/exit');
